import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { IResponseRemoveFromBasket } from '@df/session/api/basket/basket.service';
import { TruncatePipe } from '@df/ui/common/truncate.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { GiftboxBasketItemComponentDef } from './giftbox-basket-item.component.def';

@Component({
    selector: 'giftbox-checkout-item',
    templateUrl: './giftbox-checkout-item.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, DfImageDirective, PriceComponent, ResultComponent, TruncatePipe, TranslatePipe]
})
export class GiftboxCheckoutItemComponent extends GiftboxBasketItemComponentDef {
    checkoutRemove(): Promise<IResponseRemoveFromBasket> {
        return this.item.remove(this.removeStatus, undefined, undefined, true);
    }
}
